<template>
  <v-row
    class="fill-height"
    no-gutters
  >
    <template v-for="(modal, index) in cardOptionsModals">
      <DynamicModalComponent
        v-if="modal.props.value"
        :key="index"
        :component-name="modal.componentName"
        :custom-props="modal.props"
        :events="modal.events"
      />
    </template>

    <BarChart
      :request-status="requestStatus"
      :categories="categories"
      :series="series"
      :title="title"
      :item-id="itemId"
      :card-options="cardOptions"
      :has-custom-filter="true"
      :open-filter="openGenericFilterModal"
      v-bind="$attrs"
      @reload="getData"
    />
  </v-row>
</template>

<script>
import BarChart from '@/components/cards/models/BarChart';
import EventBus from '@/utils/event-bus';
import highchartsBasics from '@/mixins/highcharts-basics';
import loversHatersModel from '@/mixins/lovers-haters-model';
import colors from '@/utils/colors';
import DynamicModalComponent from '@/components/modal-model/DynamicModalComponent';

export default {
  name: 'InterestLovers',
  components: {
    BarChart,
    DynamicModalComponent,
  },
  mixins: [
    highchartsBasics,
    loversHatersModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    isExpandedCard: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      categories: [],
      rawData: [],
      cardOptions: {
        plotOptions: {
          series: {
            stacking: 'normal',
          },
        },
      },
      cardModalMethods: {
        openGenericFilterModal: this.openGenericFilterModalModal,
      },
    };
  },
  computed: {
    data() {
      if (this.rawData) {
        return this.isExpandedCard ? this.rawData : this.rawData.slice(0, this.maxItemsToBeDisplayed);
      }
      return [];
    },
    series() {
      if (!this.rawData) {
        return [];
      }

      return [
        {
          name: this.$t('components.InterestLovers.interests'),
          color: colors.defaultSerieColor,
          data: this.data.map((value) => value),
        },
      ];
    },
  },
  methods: {
    applyFilter(options) {
      this.rawData = [];
      this.categories = [];
      this.requestStatus = 'loading';
      this.filterDialog = false;

      const promisses = this.getPromisses();

      Promise.all(promisses).then(async (responses) => {
        const users = await this.aggregateResponses(responses);
        const uids = users.map((user) => {
          return user.uid;
        });

        this.card.props.filter.uids = {
          value: uids,
        };
        this.setOverview(options);

        if (options?.silentRefresh) {
          EventBus.$emit('updated', { itemId: this.itemId });
        }
        this.saveCards();
        this.requestStatus = 'success';
      }).catch((err) => {
        console.error(err);
        this.requestStatus = 'error';
      });
    },
    setOverview(options) {
      this.getWarroomService({
        itemId: this.itemId,
        servicePath: 'monitoringOverview',
      })
        .then((response) => {
          const INDEX_VALUES = 1;

          response.talking_about.publishers[INDEX_VALUES].forEach(([category, value]) => {
            this.categories.push(category);
            this.rawData.push(value);
          });
          this.requestStatus = 'success';

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch((err) => {
          console.error(err);
          this.requestStatus = 'error';
        });
    },
  },
};

</script>
